import axios from "axios";
import {contentType, requestTimeout} from "@/config/settings";
import router from "@/router";

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: requestTimeout,
    withCredentials: true,
    crossDomain: true,
    headers: {
        "Content-Type": contentType,
    },
});
service.interceptors.request.use(config => {
        if (sessionStorage.getItem('accessToken')) {
            config.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken')
        }
        return config;
    },
);

service.interceptors.response.use((response) => {
        const {status, data, config} = response;
        const {msg} = data;
        if (status != 200) {
            console.info("http error:" + config.url + status + msg);
            router.push({path: "/error"});
            return null;
        }
        return data;
    },
    error => {
        console.info("response:" + error);
        router.push({path: "/error"});
        return null;
    }
);
export default service;
